import { HttpClient } from 'packages/lib/api/rest-easy/http-client';
import {
  OperationsBackEndError,
  OperationsBackEndErrorSchema,
} from 'packages/lib/api/annotations-ops/contract/error';
import { getDefaultHeaders } from 'packages/lib/api/rest-easy/utils';

export const operationsClient = new HttpClient<OperationsBackEndError>({
  backend: 'annotationsAppApi',
  errorSchema: OperationsBackEndErrorSchema,
  getDefaultHeaders,
  getErrorMessage: (payload) => payload.message,
  onResponseError: (error) => {
    console.log(error.payload.message);
  },
});
